import BackendService from './BackendService';

export default class DepositsService {
  static getAllDeposits(startDate, endDate, applicantName) {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (applicantName) params.applicantName = applicantName;

    return BackendService.get('/deposits/all', { params });
  }

  static refundDeposit(depositId) {
    return BackendService.post(`/deposits/${depositId}/refund`);
  }

  static createStripeWebhook(dealerId) {
    return BackendService.post(`/deposits/webhook/${dealerId}`);
  }

  static deleteStripeWebhook(dealerId) {
    return BackendService.delete(`/deposits/webhook/${dealerId}`);
  }
}
